const buildGiftCodePayments = ({ payed, payNow, hotelPaymentBase, giftCodeDiscount }) => {
  const payLater = hotelPaymentBase - payed - payNow + giftCodeDiscount;
  const payments = [];
  if (payed) payments.push({ text: '_%pagado%_', amount: payed });
  if (payNow) payments.push({ text: '_%pagar ahora%_', amount: payNow });
  if (payLater) payments.push({ text: '_%pagar en el hotel%_', amount: payLater });
  return payments;
};

const buildDefaultTMSPayment = ({ newCofSuccess, prepaymentAmount }) => [
  {
    text: newCofSuccess ? '_%pagado%_' : '_%pagar ahora%_',
    amount: prepaymentAmount || '',
  },
];

// GLOSARIO.md FCL-003
export const buildTMSPayments = params => {
  const { giftCodeDiscount, summaryPriceBreakdown, displayedTotalPrice } = params;

  if (giftCodeDiscount) return buildGiftCodePayments(params);
  if (summaryPriceBreakdown) return [{ text: '_%pagar en el hotel%_', amount: displayedTotalPrice }];
  return buildDefaultTMSPayment(params);
};
